import { FlexBox, IconButton, InputText } from '@dixa/lib-shared-habla';

type FilterSearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  'data-testid'?: string;
};

export const FilterSearchInput = ({
  value,
  onChange,
  placeholder,
  'data-testid': dataTestId,
}: FilterSearchInputProps): JSX.Element => (
  <div data-testid={dataTestId}>
    <InputText
      type="search"
      autoFocus
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      suffix={{
        type: 'custom',
        value: (
          <FlexBox alignItems="center" padding="0 100">
            <IconButton
              variant="tertiary"
              icon={value ? 'close' : 'search'}
              onClick={value ? () => onChange('') : undefined}
            />
          </FlexBox>
        ),
        noWrap: true,
      }}
    />
  </div>
);
